const carouselItems = [
  {
    title: '独家追踪：某剧组拍摄现场全揭秘',
    tag: '深度专题',
    desc: '深入探访年度最受关注的影视项目，独家披露幕后制作细节与演员真实状态，还原镜头之外的精彩故事。多位剧组核心成员首次接受深度访谈，曝光拍摄过程中的高能瞬间与鲜为人知的创作幕后。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20set%20atmosphere%20with%20warm%20lighting%2C%20camera%20equipment%20silhouettes%2C%20dramatic%20backlight%2C%20movie%20production%20vibe%2C%20editorial%20photography%20style%2C%20no%20faces%2C%20artistic%20blur&width=600&height=400&seq=carousel-1-x3&orientation=landscape',
  },
  {
    title: '2026上半年娱乐圈大事件全回顾',
    tag: '年度盘点',
    desc: '从明星婚变到综艺爆款，从直播翻车到品牌解约，全面梳理今年上半年最具话题度的娱乐事件时间线。每一件都曾霸占热搜，每一次反转都让吃瓜群众直呼过瘾，带你重温那些令人难忘的吃瓜瞬间。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20timeline%20collage%20with%20warm%20coral%20and%20gold%20tones%2C%20floating%20geometric%20shapes%2C%20news%20headline%20style%20composition%2C%20editorial%20design%2C%20modern%20minimalist%2C%20no%20text%2C%20no%20faces&width=600&height=400&seq=carousel-2-x4&orientation=landscape',
  },
  {
    title: '网红经济：流量背后的商业密码',
    tag: '行业观察',
    desc: '当直播带货进入下半场，头部网红的商业版图正在悄然变化。从签约模式到分成比例，从平台博弈到个人品牌化，深度剖析网红经济背后的资本逻辑与行业趋势，揭示流量变现的真实内幕与未来走向。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20digital%20media%20studio%20with%20warm%20ambient%20lighting%2C%20streaming%20equipment%2C%20abstract%20data%20visualization%2C%20business%20and%20technology%20theme%2C%20editorial%20style%2C%20no%20faces&width=600&height=400&seq=carousel-3-x5&orientation=landscape',
  },
  {
    title: '吃瓜文化：为什么我们爱看八卦？',
    tag: '文化解读',
    desc: '从心理学到社会学，探究人类对八卦信息的天生好奇与社交需求。娱乐圈爆料为何总能引爆社交网络？吃瓜行为背后隐藏着怎样的群体心理机制？带你从学术视角重新审视这个全民娱乐时代的社会现象。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20abstract%20social%20media%20concept%20art%2C%20floating%20conversation%20bubbles%2C%20network%20connections%2C%20coral%20and%20amber%20color%20palette%2C%20modern%20editorial%20illustration%2C%20no%20text%2C%20no%20faces&width=600&height=400&seq=carousel-4-x6&orientation=landscape',
  },
];

export default function SectionCarousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-7 rounded-full bg-accent-500"></span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            焦点专题
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-primary-200/60 transition-colors cursor-pointer"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3 group-hover:text-primary-600 transition-colors" style={{ fontFamily: 'var(--font-heading)' }}>
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}